export default {
      id: "georadar-radius-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#georadar-radius",
      toString: function () {
        return this.url;
      }
    }